const igaModel = Object.freeze({
  NoIga: 1,
  Model1AIga: 2,
  Model1BIga: 3,
  Model2Iga: 4,
  UsTerritory: 5,
  Us: 6
});

export default igaModel;
